import React, { useEffect, useState } from 'react'
import {
  Box,
  Typography,
  Button,
  Grid,
  makeStyles,
  CircularProgress,
  Backdrop,
  Fade,
  TextField,
  Select,
  MenuItem
} from '@material-ui/core'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { PatientStore } from '../../stores'
import { NETWORK_STATUS, PATIENT_ID } from '../../Constants'
import { useParams } from 'react-router'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Autocomplete } from '@material-ui/lab'
import useDebounce from '../../customHooks/useDebounce'

const EditLabOrders = ({ open, defaultValues, handleClose ,document }) => {
  const classes = useStyles()
  const params = useParams()
  const [testValue, setTestValue] = useState(null)
  const [report, setReport] = useState([])
  const [searchString, setSearchString] = useState('')
  const [fileNotFound, setFileNotFound] = useState(false)

  const debouncedSearchTerm = useDebounce(searchString, 300)

  const { editLab, getLabRecordsNames } = PatientStore.useStoreActions(
    actions => ({
      ...actions.patients
    })
  )

  const {
    networkStatus,
    lablist,
    labsFetchingStatus
  } = PatientStore.useStoreState(state => ({
    ...state.patients
  }))

  const submit = async values => {
    if (report.length) {
      const file = report[0]

      editLab({
        ...values,
        labId: defaultValues.labs_id,
        documentId: defaultValues.document_id,
        patientId: localStorage.getItem(PATIENT_ID),
        appointmentId: '',
        reportName: file.name,
        report: await toBase64(file)
      })

      setTimeout(() => {
        handleClose()
      }, 500)
      return
    }
    editLab({
      ...values,
      labId: defaultValues.labs_id,
      patientId: localStorage.getItem(PATIENT_ID),
      documentId: defaultValues.document_id,
      appointmentId: ''
    })

    setTimeout(() => {
      handleClose()
    }, 500)
  }

  useEffect(() => {
    getLabRecordsNames({
      table_config_search_string: searchString
    })
  }, [debouncedSearchTerm])

  const handleSearchChange = event => {
    setSearchString(event.target.value)
  }
  const handleFileChange = event => {
    setFileNotFound(true)
    setReport(event.target.files)
  }

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
    touched
  } = useFormik({
    initialValues: {
      testName: defaultValues.testname,
      type: 'initial',
      instructions: defaultValues.instructions,
      picture: document ? document : ""
    },
    onSubmit: submit,
    validationSchema
  })

  const isError = (error, touched) => error && touched

  const handlelabsChange = (event, value) => {
    if (value?.type === 'others') {
      setFieldValue('type', value?.type)
    } else {
      setFieldValue('type', value?.lab_id)
    }
    setFieldValue('testName', value?.testname)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title" style={{width:'450px'}} className={classes.ModalHead}>
        <h3> Update Lab Reports</h3>
      {/* <DialogTitle id="form-dialog-title">
        Update Lab Reports
      </DialogTitle> */}
      <DialogContent>
        <Box className={classes.ModalForm}>
          <form noValidate={true} onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} style={{ padding: '8px 0' }}>
                <Autocomplete
                  value={values.testName}
                  options={lablist}
                  style={{ width: '100%' }}
                  getOptionLabel={option => {
                    if (option.type === 'others') {
                      let added = values.testName === option?.testname
                      if (added) {
                        return option?.testname
                      } else {
                        return option.title
                      }
                    }
                    if (option.inputValue) {
                      return option.title
                    }
                    return option?.testname ? option?.testname : option
                  }}
                  loadingText="Loading..."
                  noOptionsText={
                    labsFetchingStatus ? 'Loading...' : 'No Options'
                  }
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  onChange={handlelabsChange}
                  filterOptions={(options, params) => {
                    const filtered = options
                    if (
                      options.length === 0 &&
                      !labsFetchingStatus &&
                      params.inputValue !== ''
                    ) {
                      filtered.push({
                        type: 'others',
                        title: `Add "${params.inputValue}"`,
                        testname: params.inputValue
                      })
                    }
                    return filtered
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      className={classes.Input}
                      label="Lab Record Name *"
                      name={'testName'}
                      value={values.testName}
                      // variant="outlined"
                      error={isError(errors.testName, touched.testName)}
                      helperText={
                        isError(errors.testName, touched.testName)
                          ? errors.testName
                          : null
                      }
                      loading={labsFetchingStatus}
                      onChange={handleSearchChange}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {labsFetchingStatus ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        )
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} style={{ padding: '8px 0' }}>
                <Box className={classes.InputCol}>
                  <TextField
                    multiline={true}
                    className={classes.textArea}
                    variant={'outlined'}
                    label="Instructions *"
                    name={'instructions'}
                    error={isError(errors.instructions, touched.instructions)}
                    helperText={
                      isError(errors.instructions, touched.instructions)
                        ? errors.instructions
                        : null
                    }
                    value={values.instructions}
                    onChange={handleChange}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} style={{ padding: '8px 0' }}>
                <input
                  accept="image/*,.pdf,.doc*"
                  className={classes.uploadInput}
                  id="file-input"
                  name="picture"
                  type="file"
                  onChange={handleFileChange}
                />
                <label htmlFor="file-input" style={{width:'100%'}}>
                  <Button
                    variant="contained"
                    color="#111d4e"
                    size="large"
                    className={classes.button}
                    component="span"
                    startIcon={<CloudUploadIcon />} style={{ width:'100%'}}>
                    Upload Report *
                  </Button>
                </label>
                {/* {fileNotFound == false ? (
                  <Typography className={classes.error}>
                    File is mandatory
                  </Typography>
                ) : ""} */}
                {report.length ? (
                  <Typography className={classes.fileUploaded}>
                    File Uploaded
                  </Typography>
                ) : null}
              </Grid>
            </Grid>
          </form>
        </Box>
      </DialogContent>
      <DialogActions style={{ padding: '20px 40px' }}>
        <Button onClick={handleClose} className={classes.modalSecondaryButton}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} className={classes.modalPrimaryButton}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const validationSchema = yup.object().shape({
  testName: yup.string().trim().required('Test name is required'),
  type: yup.string().trim().required('Test name is required'),
  instructions: yup
  .string()
  .trim()
  .required('Instructions are required')
  .max(250, 'You have exceeded the character limit')
})

const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

const useStyles = makeStyles(theme => ({
  error: {
    color: theme.palette.error.main
  },
  fileUploaded: {
    color: theme.palette.success.main,
    margin: '8px 0'
  },
  uploadInput: {
    display: 'none'
  },
  textArea: {
    width: '100%'
  },
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  button:{
    fontSize:'14px'
  },
  formControl: {
    width: '100%'
  },
  textField: {
    width: '100%'
  },
  select: {
    width: '100%'
  },
  InputCol: {
    '& .MuiInput-root': {
      width: '100%'
    }
  },
  Textara: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, 0.42)',
    padding: '10px'
  },
  ModalBox: {
    width: '450px',
    background: '#fff',
    padding: '0px',
    '@media (max-width:767px)': {
      width: '100%'
    },
    // height:'400px',
    '& h2': {
      textAlign: 'left',
      fontSize: '20px',
      color: '#fff',
      background: '#3f4b79',
      padding: '10px 20px',
      '& span': {
        float: 'right',
        color: '#fff',
        cursor: 'pointer'
      }
    }
  },
  ModalForm: {
    width: '100%',
    padding: '20px',
    '@media (max-width:767px)': {
      padding: '10px',
      height: '400px',
      overflowY: 'auto'
    }
  },
  DownloadBtn: {
    width: '120px',
    background: '#3f4b79',
    height: '40px',
    textAlign: 'center',
    color: '#fff',
    lineHeight: '40px',
    fontSize: '14px',
    fontWeight: '600',
    borderRadius: '50px',
    border: 'none',
    cursor: 'pointer',
    margin: '20px auto 0',
    display: 'block'
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalPrimaryButton: {
    backgroundColor: '#111d4e',
    padding: '5px 20px',
    borderRadius: '40px',
    color: '#fff',
    cursor: 'pointer',
    height:'40px',
    fontSize:'12px'
  },
  modalSecondaryButton: {
    backgroundColor: '#e4e4e4',
    padding: '5px 20px',
    borderRadius: '40px',
    color: '#111d4e',
    cursor: 'pointer',
    height:'40px',
    fontSize:'12px'
  },
  ModalHead: {
    width:'500px',
    margin:'0px auto',
    fontFamily:'Poppins',
    '& h3':{
      padding:'15px 24px 10px',
      fontSize:'18px',
      marginBottom:'0px',
      borderBottom:'1px #ccc solid',
      fontWeight:'600'
    }
  },
  errMsg: {
    color: 'red',
    fontSize: '12px',
    fontFamily: 'san-serif',
    fontWeight: 'bold',
    width: 'max-content',
    position:'absolute'
  }
}))

export default EditLabOrders
